const valueContainsSearchTerm = (value, normalizedTerm) => {
  if (value == null) return false

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return String(value).toLowerCase().includes(normalizedTerm)
  }

  if (Array.isArray(value)) {
    return value.some(item => valueContainsSearchTerm(item, normalizedTerm))
  }

  if (typeof value === 'object') {
    return Object.values(value).some(item =>
      valueContainsSearchTerm(item, normalizedTerm)
    )
  }

  return false
}

const itemMatchesSearchTerm = (item, searchTerm) => {
  const terms = searchTerm.trim().toLowerCase().split(/\s+/).filter(Boolean)
  if (terms.length === 0) return true

  return terms.every(term => valueContainsSearchTerm(item, term))
}

export const filterItemsBySearchTerm = (items, searchTerm) => {
  const normalizedTerm = searchTerm.trim().toLowerCase()
  if (!normalizedTerm) return null

  return items.filter(item => itemMatchesSearchTerm(item, normalizedTerm))
}
